import client from 'providers/fetchClient'

import { formatCurrency, formatDateTime } from 'utils/formatters'
import { translatePackageOrderStatus } from 'utils/translators'

export const fetchAll = async ({ sortBy, pagination }) => {
  let params = {}

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/package-orders', { params })

  const packageOrders = data.data.map(packageOrder => ({
    ...packageOrder,
    packages: packageOrder.items_count,
    receipt_url: packageOrder.boleto?.receipt,
    purchase_date: formatDateTime(packageOrder.created_at),
    amount: formatCurrency(packageOrder.amount),
    payment_status: translatePackageOrderStatus(packageOrder),
  }))

  return {
    packageOrders,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export default {
  fetchAll,
}
